/**
 * Shop Pay installments threshold (PDP round 2, B2 follow-up, Sasha 2026-10-05:
 * "when it's below 35$ can go on 2 lines then, but not when it's above").
 *
 * main-product stamps the installments wrapper (.product-form around
 * #product-form-installment-<section>) with data-paex-spt-min (threshold in
 * cents, Theme settings → Party Expert → Shop Pay installments minimum) and
 * data-paex-spt-below when the selected variant's price is under it. Below the
 * threshold Shopify prints the longer "Pay over time for orders over $35.00
 * with Shop" line, which paex-pdp-restyle.css lets wrap (2-line reserve); at or
 * above it the one-line rule stays.
 *
 * This keeps the attribute in step with the selected variant: one subscriber
 * on the theme's own variantChange pub/sub (the event the other paex PDP
 * scripts use), no other listeners. webvista / PUB_SUB_EVENTS are global.js
 * lexical consts, so they are feature-detected with typeof.
 */
(function () {
  if (window.paexSptBound) return;
  if (typeof webvista === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined' || typeof webvista.subscribe !== 'function') return;
  window.paexSptBound = true;

  webvista.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.variant || typeof data.variant.price !== 'number') return;
    var form = document.getElementById('product-form-installment-' + data.sectionId);
    var wrap = form && form.closest('[data-paex-spt-min]');
    if (!wrap) return;
    var min = parseFloat(wrap.getAttribute('data-paex-spt-min'));
    if (isNaN(min)) return;
    wrap.toggleAttribute('data-paex-spt-below', data.variant.price < min);
  });
})();
